/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconFlag3 = createReactComponent("outline", "flag-3", "IconFlag3", [["path", { "d": "M5 14h14l-4.5 -4.5l4.5 -4.5h-14v16", "key": "svg-0" }]]);

export { IconFlag3 as default };
//# sourceMappingURL=IconFlag3.mjs.map
